import { validateSync } from "./sync"
import { validateAsync } from "./async"

export async function validateField(def: any, values: Record<string, unknown>): Promise<string> {
    const syncError = validateSync(def, values)
    if (syncError) return syncError

    const asyncError = await validateAsync(def, values)
    if (asyncError) return asyncError

    return ""
}
